/* eslint-disable jsx-a11y/anchor-has-content,react/no-unused-prop-types,jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import classNames from 'classnames';

import { selectUserId } from 'mt-react-common/modules/users/common/reducers/states/authAccount';

import {
  changeFieldRoomName,
  selectFieldUserIds,
  selectFieldRoomName,
  selectUserModelById
} from 'mt-react-common/modules/messenger/reducers/static/forms/createGroupRoom/createGroupRoomForm';

import RemoveUserItem from './common/RemoveUserItem';

const messengerModuleRN = 'messengerModule.forms.createRoomForm';

// eslint-disable-next-line react/prefer-stateless-function
class CreatePrivateRoomBlock extends Component {
  render() {
    const hasError = fieldErrors => fieldErrors.length > 0;
    const errorDesc = fieldErrors => {
      if (fieldErrors.length > 0) {
        return (
          <React.Fragment>
            <small className="help-block m-b-5">
              <i className="fa fa-exclamation-triangle" />{' '}
              {fieldErrors[0].message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };
    return (
      <div>
        <div
          className={classNames('form-group', {
            'has-error': hasError(this.props.fieldRoomName.errors)
          })}
        >
          <label className="control-label" htmlFor="groupName">
            {t('Название диалога')}
          </label>
          <input
            className="form-control"
            id="groupName"
            placeholder={t('Название диалога')}
            type="text"
            value={this.props.fieldRoomName.value}
            onChange={e => this.props.changeFieldRoomName(e.target.value)}
          />
          {errorDesc(this.props.fieldRoomName.errors)}
        </div>
        <div
          className={classNames('form-group', {
            'has-error': hasError(this.props.fieldUserIds.errors)
          })}
        >
          <label className="control-label" htmlFor="username">
            {t('Участники диалога')}
          </label>
          {this.props.fieldUserIds.value.length > 0 ? (
            <table className="table">
              <tbody>
                {this.props.fieldUserIds.value.map((itemId, index) => {
                  if (itemId !== this.props.authUserId.toString()) {
                    return (
                      <RemoveUserItem
                        key={`removeUserItem${itemId}`}
                        item={this.props.selectUserModelById(itemId)}
                        index={index}
                      />
                    );
                  }
                  return null;
                })}
              </tbody>
            </table>
          ) : (
            <div className="alert alert-default text-center">
              <p>{t('Добавьте участников в группу')}</p>
            </div>
          )}
          {errorDesc(this.props.fieldUserIds.errors)}
        </div>
      </div>
    );
  }
}

CreatePrivateRoomBlock.propTypes = {
  // CONNECT
  authUserId: PropTypes.number.isRequired,
  fieldRoomName: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldUserIds: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,

  changeFieldRoomName: PropTypes.func.isRequired,
  selectUserModelById: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  authUserId: selectUserId(state),
  fieldRoomName: selectFieldRoomName(state, messengerModuleRN),
  fieldUserIds: selectFieldUserIds(state, messengerModuleRN),
  selectUserModelById: itemId =>
    selectUserModelById(state, messengerModuleRN, itemId)
});

const mapDispatchToProps = dispatch => ({
  changeFieldRoomName: value =>
    dispatch(changeFieldRoomName(messengerModuleRN, value))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreatePrivateRoomBlock);



// WEBPACK FOOTER //
// ./src/components/Messenger/content/MessengerGroupRoomFormPopUp/CreatePrivateRoomBlock.js